import React, { useState } from 'react';

// Datos mock de ventas concretadas
const ventasMock = [
  { id: 1, cliente: 'Pedro Gómez', producto: 'Internet 100Mb', fecha: '2024-06-01', estado: 'CONCRETADA', seguimiento: false, comentario: '' },
  { id: 2, cliente: 'Lucía Torres', producto: 'TV HD', fecha: '2024-06-02', estado: 'CONCRETADA', seguimiento: true, comentario: 'Cliente satisfecho' },
  { id: 3, cliente: 'Carlos Ruiz', producto: 'Internet 200Mb', fecha: '2024-06-03', estado: 'CONCRETADA', seguimiento: false, comentario: '' },
];

const CalidadPanel = () => {
  const [ventas, setVentas] = useState(ventasMock);
  const [comentario, setComentario] = useState({});

  const handleSeguimiento = (id) => {
    setVentas(ventas.map(v => v.id === id ? { ...v, seguimiento: true, comentario: comentario[id] || '' } : v));
    setComentario({ ...comentario, [id]: '' });
  };

  return (
    <div style={{marginLeft:280, padding:'32px 24px', minHeight:'80vh', background:'#f8fafc'}}>
      <h2 style={{fontSize:'2.2rem',fontWeight:900,color:'#1a237e',marginBottom:32,textAlign:'center'}}>Panel Calidad - Seguimiento de Ventas</h2>
      <div style={{background:'#fff',borderRadius:16,boxShadow:'0 2px 16px rgba(124,58,237,0.08)',padding:24,maxWidth:1000,margin:'0 auto'}}>
        <h3 style={{color:'#7c3aed',fontWeight:700,marginBottom:12}}>Ventas concretadas</h3>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{background:'#f3f4f6'}}>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Cliente</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Producto</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Fecha</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Seguimiento</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Comentario</th>
              <th style={{padding:'10px 8px',color:'#7c3aed',fontWeight:700}}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {ventas.map(v => (
              <tr key={v.id}>
                <td style={{padding:'8px'}}>{v.cliente}</td>
                <td style={{padding:'8px'}}>{v.producto}</td>
                <td style={{padding:'8px'}}>{v.fecha}</td>
                <td style={{padding:'8px'}}>{v.seguimiento ? <span style={{color:'#34d399',fontWeight:700}}>Verificado</span> : <span style={{color:'#f59e42'}}>Pendiente</span>}</td>
                <td style={{padding:'8px'}}>
                  {v.seguimiento ? v.comentario : (
                    <input
                      type="text"
                      value={comentario[v.id] || ''}
                      onChange={e => setComentario({ ...comentario, [v.id]: e.target.value })}
                      placeholder="Comentario de seguimiento"
                      style={{padding:'6px 10px',borderRadius:6,border:'1.5px solid #d1d5db',width:'100%'}}
                    />
                  )}
                </td>
                <td style={{padding:'8px'}}>
                  {!v.seguimiento && (
                    <button
                      onClick={() => handleSeguimiento(v.id)}
                      style={{background:'#7c3aed',color:'#fff',border:'none',borderRadius:6,padding:'8px 16px',fontWeight:700,cursor:'pointer'}}
                    >
                      Marcar seguimiento
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CalidadPanel; 